export enum OrderPrioritizationProperties {
  dialogInputWidth = '650px'
}
